import {gql} from "@apollo/client";

export const GetUserByIdsQuery = gql`
    query GetUserByIds($idIn: [String!]!) {
        getUserByIds(idIn: $idIn) {
            id
            firstName
            profilePhoto
            accountRole
            staffFields {
                department
            }
            country {
                code
            }
            isOnline
            degrees {
                degreeType
                degree {
                    name
                }
            }
        }
    }
`;
